import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
      meta: {
        title: 'Legal Score - Início'
      }
    },
    {
      path: '/formulario',
      name: 'formulario',
      component: () => import('@/views/FormView.vue'),
      meta: {
        title: 'Legal Score - Formulário'
      }
    },
    {
      path: '/relatorio',
      name: 'relatorio',
      component: () => import('@/views/ReportView.vue'),
      meta: {
        title: 'Legal Score - Relatório'
      }
    },
    // Outras rotas serão criadas conforme necessário
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  // Set page title
  document.title = to.meta.title || 'Legal Score'
  next()
})

export default router
